import {FormBuilderAnswerableDate, FormBuilderQuestion} from "@/types";
import {ExclamationCircleIcon, XMarkIcon} from '@heroicons/react/20/solid'
import {add, format, sub} from "date-fns";
import DatePicker from 'react-date-picker';
// import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import {CalendarIcon} from "@heroicons/react/24/outline";
interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

export default function AnswerableDate<T extends { answerable: FormBuilderAnswerableDate }>({
                                                                                                question,
                                                                                                data,
                                                                                                setData,
                                                                                                hasError,
                                                                                                settings
                                                                                            }: Props) {

    // check if the default is null and convert it to a string because React doesnt like null
    const value = !data[question.id] ? "" : data[question.id];

    return (
        <div className="relative mt-1">
            <DatePicker
                minDate={question.answerable.min_days_ago ? sub(new Date(), {days: question.answerable.min_days_ago}) : undefined}
                maxDate={question.answerable.max_days_ahead ? add(new Date(), {days: question.answerable.max_days_ahead}) : undefined}
                required={"is_required" in question.answerable ? question.answerable.is_required : false}
                className={`w-full border rounded shadow-sm block disabled:opacity-50 disabled:cursor-not-allowed ${hasError
                        ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500'
                        : `border-transparent text-gray-600 focus:border-[${settings.primaryColour}] focus:ring-[${settings.primaryColour}] `}`}
                calendarClassName={''}
                clearIcon={<XMarkIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>}
                calendarIcon={<CalendarIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>}
                locale={"en-GB"}
                format={"dd/MM/y"}
                onChange={(date) => {
                    if(date == null) {
                        setData(question.id, null)
                        return
                    } else {
                        const newValue = format(date, 'yyyy-MM-dd')
                        setData(question.id, newValue)
                    }
                }}
                value={(value == 'today' ? new Date() : value)}
                defaultValue={(value == 'today' ? new Date() : value)}
                dayPlaceholder={'dd'}
                monthPlaceholder={'mm'}
                yearPlaceholder={'yyyy'}
                showLeadingZeros={true}
            />
            {(hasError) ? (errorBadge()) : (<></>)}
        </div>
    );

}

function errorBadge() {
    return (<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
    </div>)
}
